import { createSelector } from 'reselect';

export const selectAuthSlice = state => state.auth;
export const selectUser = createSelector(
  selectAuthSlice,
  slice => slice.user
);
export const isLoggedIn = createSelector(
  selectUser,
  user => !!user
);
export const isLoggingIn = createSelector(
  selectAuthSlice,
  slice => slice.isLoggingIn
);
export const selectLoginError = createSelector(
  selectAuthSlice,
  slice => slice.loginError
);
